export default __webpack_public_path__ + "static/ola-e9e5a0da3c8d58e7f1c9440a7b19344d.svg";